<template>
  <div>
    <v-main>
      <v-container fluid>
        <!-- <app-headline :title="title + ' ของ ' + this.$username" /> -->
        <v-row>
          <v-col>
            <v-card
              class="pt-3 pb-6"
              :class="$vuetify.breakpoint.smAndUp ? 'px-8' : 'px-5'"
            >
              <v-container class="py-0">
                <list-search></list-search>

                <v-divider class="mt-3 mb-6"></v-divider>
                <v-row v-if="!dataRecord">
                  <v-col class="text-center grey--text">
                    <h1 class="py-4">ไม่พบข้อมูล</h1>
                  </v-col>
                </v-row>
                <v-row
                  v-else
                  v-for="(data, index) in dataRecord"
                  :key="'datalist-' + index"
                >
                  <v-col class="pt-0 pb-1">
                    <cert-list :data="data" type="admin" />
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import CertList from '@/components/reqcer/CertList.vue'
import listSearch from '@/components/reqcer/admin/listSearch.vue'
export default {
  components: {
    CertList,
    listSearch
  },
  data() {
    return {
      title: 'สถานะคำขอรับรอง',
      dataRecord: []
    }
  },
  computed: {},
  watch: {
    $route() {
      this.onSearch()
    }
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    async onSearch() {
      let body = {
        th: this.$route.query.th,
        en: this.$route.query.en,
        isWait: this.$route.query.isWait,
        isProcess: this.$route.query.isProcess,
        isDone: this.$route.query.isDone,
        isBank: this.$route.query.isBank,
        isVisa: this.$route.query.isVisa,
        isOther: this.$route.query.isOther,
        FirstName: this.$route.query.firstName,
        LastName: this.$route.query.lastName,
        OrganIDLV1: this.$route.query.orgParent,
        OrganIDLV2: this.$route.query.orgChild,
        CountryTha: this.$route.query.country,
        StartDate: this.$route.query.StartDate,
        EndDate: this.$route.query.EndDate,
        EarlyStatus: this.$route.query.EarlyStatus
      }
      const res = await this.apiGetList(body)
      this.dataRecord = res.data.data
      // console.log(body)
    },
    async apiGetList(body) {
      try {
        const res = await this.$store.dispatch('reqCer/getAdminList', body)
        // console.log(res)s
        return res
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
